<template>
    <form @submit="onFormSubmit" action="xx">
        <div class="left rsa" id="cisViewPort">
            <DxLoadPanel :position="position" class="rsa-loadpanel"
                         v-model:visible="loadIndicatorVisible"
                         :show-indicator="true"
                         :copy-root-classes-to-wrapper="true"
                         :show-pane="true"
                         :shading="true"
                         :width="150"
                         message="Please wait ..."
                         shading-color="rgba(0,0,0,0.4)" />

            <div class="resp-form">
                <div class="rsa-header">
                    <div class="lgi-logo">
                    </div>
                    <div class="rsa-welcome">
                        Reset Password
                    </div>
                    <div class="rsa-welcome-text">
                        <div class="pwd-rule">
                            {{pwdRuleMsg}}
                        </div>
                    </div>
                </div>
                <div v-if="tokenValid">
                    <div class="field">
                        <DxTextBox v-model:text="record.pwd1"
                                   :show-clear-button="false"
                                   label="Password"
                                   label-mode="static"
                                   mode="password">
                            <DxValidator>
                                <DxRequiredRule message="Password is required" />
                            </DxValidator>
                        </DxTextBox>
                        <password-meter :password="record.pwd1" />
                    </div>
                    <div class="field">
                        <DxTextBox v-model:text="record.pwd2"
                                   :show-clear-button="false"
                                   label="Confirm Password"
                                   label-mode="static"
                                   mode="password">
                            <DxValidator>
                                <DxRequiredRule message="Confirm Password is required" />
                                <DxCompareRule :comparison-target="passwordComparison"
                                               message="Password and Confirm Password do not match" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                    <div class="field">
                        <div class="rsa-err-msg" v-if="hasMessage">
                            {{ errorMessage }}
                        </div>
                        <div class="rsa-btns">
                            <!--<DxValidationSummary id="summary" />-->
                            <DxButton class="restBtn"
                                      text="Reset Password"
                                      :use-submit-behavior="true"
                                      type="success" />
                        </div>
                    </div>
                </div>
                <div class="LoginErrorMsg">
                    <div v-if="falseTokenMessageVisible">
                        <p>
                            Der Aktivierungslinks ist ungültig.
                        </p>
                        <p>
                            Entweder der Aktivierungslink wurde bereits verwendet oder er ist zeitlich abgelaufen.
                        </p>
                    </div>
                    <div v-if="hasServerError">
                        <p>
                            Der Aktivierung ist aufgrund eines Serverfehlers fehlgeschlagen.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </form>
</template>

<script>
    import { DxLoadPanel } from 'devextreme-vue/load-panel'
    import DxTextBox from 'devextreme-vue/text-box';
    import { DxButton } from 'devextreme-vue/button';
    import axios from 'axios'
    import $ from 'jquery'
    import passwordMeter from "vue-simple-password-meter";
    import {
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        //DxPatternRule,
        //DxStringLengthRule,
        //DxRangeRule,
        //DxAsyncRule,
    } from 'devextreme-vue/validator';
    const baseUri = "WebApi.asmx/api/user";
    export default {
        name: 'ActivateNewAccount',
        components: {
            DxLoadPanel,
            passwordMeter,
            DxButton,
            DxTextBox,
            DxValidator,
            DxRequiredRule,
            DxCompareRule,
        },
        data() {
            return {
                loadIndicatorVisible: false,
                falseTokenMessageVisible: false,
                hasServerError: false,
                pwdRuleMsg: "",
                pwdRule: "",
                record: {
                    pwd1: "",
                    pwd2: ""
                }
            };
        },

        computed: {
            topicTypeList() {
                return this.$store.state.createTopicStore.topicTypeList
            },
            createTopicDisabled() {
                return this.tty == null || this.tty == {}
            },
            rc() {
                return this.$route.query.rc
            },
            tokenValid() {
                return !this.$data.falseTokenMessageVisible
            },
            pwdValid() {
                return RegExp(this.$data.pwdRule).test(this.$data.record.pwd1)
            },
            pwdDiff() {
                const rec = this.$data.record
                return !(rec.pwd1.length > 1 && rec.pwd1 != rec.pwd2)
            },
            pwdCorrect() {
                return this.record.pwd1 == this.record.pwd2 && this.pwdValid && this.tokenValid
            }
        },
        mounted: function () {
            this.validateToken()
        },
        methods: {
            onFormSubmit(e) {
                this.SetPassword();
                e.preventDefault();
            },
            passwordComparison() {
                return this.record.pwd1
            },
            validateToken() {
                this.loadIndicatorVisible = true
                axios
                    .get(baseUri + '/ValidateActivationToken?RC=' + this.rc)
                    .then(res => {
                        this.loadIndicatorVisible = false
                        if (res.data.success == false) {
                            this.$data.falseTokenMessageVisible = true
                        }
                        else {
                            this.$data.pwdRuleMsg = res.data.pwdRuleMsg
                            this.$data.pwdRule = res.data.pwdRule
                        }
                    })
            },
            SetPassword() {
                this.loadIndicatorVisible = true
                var formData = new FormData()
                formData.append("RC", this.rc)
                formData.append("Password", this.record.pwd1)
                axios
                    .post(baseUri + '/ActivateByToken', formData)
                    .then(res => {
                        this.loadIndicatorVisible = false
                        if (res.data.success == false) {
                            this.$data.hasServerError = true
                        }
                        else {
                            $("form").attr("action", "../Login.aspx").submit();
                        }
                    })
            },

        }
    }


</script>
<style>
    .rsa .captcha-img {
    }


    .rsa .field {
        display: flex;
        flex-direction: column;
        padding: 10px 0px 10px 0px;
    }

    .rsa .rsa-err-msg {
        color: red;
        font-size: 12px;
    }

    .rsa .rsa-btns {
        display: flex;
        flex-direction: column;
        padding: 0 0px 10px 0px;
        margin-top: 10px;
        text-align: center;
    }

    .rsa div#summary {
        margin-bottom: 10px;
    }


    .rsa-loadpanel .dx-loadpanel-indicator.dx-loadindicator.dx-widget {
        margin: auto;
        display: block;
    }


    .rsa-welcome {
        font-size: 26px;
        text-align: center;
        margin-bottom: 20px;
    }

    .rsa-welcome-text {
        font-size: 15px;
        text-align: center;
        margin-bottom: 5px;
    }

    .rsa-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .rsa-footer-text {
        font-size: 12px;
    }


    .rsa .rsa-reset-btn.pq4-link {
        font-size: 11px;
        text-align: right;
        color: #7d7c84;
    }

    .pwd-rule {
        text-align: center;
        font-size: 13px;
    }
</style>
